var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-alerts alert alert-warning fade in"},[_c('i',{staticClass:"fa-lg fa fa-warning"}),_vm._v(" "+_vm._s(_vm.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }